import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

/*
Typ 1: Działania na liczbach całkowitych z nawiasami
np.  -12 + 3 · (5 − 9)
*/

function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

// ===== GENERATOR =====
export function generateTask() {
  const a = pick([-15, -12, -9, -8, -6]);
  const b = pick([2, 3, 4, 5]);
  const c = pick([3, 4, 5, 6, 7]);
  const d = pick([6, 7, 8, 9]);

  // a + b·(c − d)
  const value = a + b * (c - d);

  return {
    type: "BasicIntegerOperationsOpenTask",
    data: {
      a,
      b,
      c,
      d,
      value,
    },
    tags: ["dzialania", "liczby_calkowite", "nawiasy"],
  };
}

// ===== TREŚĆ =====
export function renderTask({ data }) {
  const { a, b, c, d } = data;

  return (
    <div style={{ textAlign: "left" }}>
      <p>
        Oblicz wartość:
        <InlineMath
          math={`${a} + ${b}\\cdot(${c} - ${d})`}
        />
        .
      </p>
    </div>
  );
}

// ===== INPUT (otwarte) =====
export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      placeholder="np. -24"
    />
  );
}

// ===== SPRAWDZANIE =====
export function checkAnswer({ data }, userAnswer) {
  if (userAnswer === null || userAnswer === undefined) return false;

  const given = Number(String(userAnswer).replace(",", "."));
  if (!Number.isFinite(given)) return false;

  return given === data.value;
}

// ===== POPRAWNA ODPOWIEDŹ =====
export function renderAnswer({ data }) {
  return <InlineMath math={`${data.value}`} />;
}

// ===== ODPOWIEDŹ UCZNIA =====
export function renderUserAnswer(userAnswer) {
  if (!userAnswer && userAnswer !== 0) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`${userAnswer}`} />;
}

// ===== WYJAŚNIENIE =====
export function renderExplanation({ data }) {
  const { a, b, c, d, value } = data;

  return (
    <div style={{ textAlign: "left" }}>
      <p><strong>Krok 1.</strong> Obliczamy wartość w nawiasie:</p>
      <BlockMath math={`${c} - ${d} = ${c - d}`} />

      <p><strong>Krok 2.</strong> Mnożymy:</p>
      <BlockMath math={`${b}\\cdot(${c - d}) = ${b * (c - d)}`} />

      <p><strong>Krok 3.</strong> Dodajemy do liczby {a}:</p>
      <BlockMath math={`${a} + ${b * (c - d)} = ${value}`} />

      <p><strong>Wynik:</strong> <InlineMath math={`${value}`} /></p>
    </div>
  );
}
